module.exports = __webpack_public_path__ + "img/curriculum.30725c71.png";